module.exports = __webpack_public_path__ + "static/media/easy_icon.f38d00cf.png";